import ReadTickIcon from './ReadTickIcon';

export default ReadTickIcon;
